import{jsxs as r,jsx as e}from"react/jsx-runtime";import o from"tailwind-styled-components";import{Dropdown as t}from"../dropdown/dropdown.js";const n=o.div`
  border-t
  border-t-gray-100
  flex
  items-center
  justify-end
  text-xs
  mt-4
  pt-2

  dark:border-t-gray-600
`,a=o.button`
  appearance-none
  bg-gray-50
  border
  border-black/5
  cursor-pointer
  ml-2
  rounded
  px-4
  py-2

  dark:bg-gray-600
`,i=o(a)`
  bg-brand-primary
  text-white

  dark:bg-brand-primary
`,d=({cancelLabel:o="No",children:d,confirmLabel:p="Yes",message:c="Are you sure?",onCancel:l,onConfirm:m,...s})=>r(t,{...s,trigger:d,children:[c,r(n,{children:[e(a,{onClick:r=>{r.preventDefault(),r.stopPropagation(),"function"==typeof l&&l()},children:o}),e(i,{onClick:r=>{r.preventDefault(),r.stopPropagation(),"function"==typeof m&&m()},children:p})]})]});export{d as Confirm,d as default};
